import styled from '@emotion/styled';
import { Variables } from '../../base';

const PanelElement = styled.div`
    padding: 8px 24px;
`;

export const FieldRow = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
`;

export const FieldColumn = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const FieldColumnAuto = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex-shrink: 0;
`;

export const FieldLabel = styled.div`
    margin: 0;
    padding: 0;
    font-size: 12px;
    font-weight: ${Variables.FontWeight.semibold};
    color: ${Variables.Colors.n70};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

